import React from 'react'

const About = () => {
  return (
    <section className='w-full h-screen'>
        <h1 className='text-center text-3xl text-red-200 font-bold py-10'>about</h1>
    </section>
  )
}

export default About